import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink,
} from "react-router-dom";

import { useState, useEffect } from "react";

import * as APIUSER from "../services/user";

export function Sueno(props) {
  // const [pacienteNHC, setPacienteNHC] = useState(0);

  // useEffect(() => {
  //   const fetchUserData = async () => {
  //     try {
  //       // Obtener los datos del usuario
  //       const currentUserData = await APIUSER.getCurrentUser();
  //       if (currentUserData) {
  //         setPacienteNHC(currentUserData?.meta?.hce);
  //       }
  //     } catch (error) {
  //       console.error("Error al obtener los datos del usuario:", error);
  //     }
  //   };

  //   fetchUserData();
  // }, [props.especialistaId]);

  // useEffect(() => {
  //   // Set up the user configuration
  //   window.chatbaseUserConfig = {
  //     user_id: props.especialistaId,
  //     user_metadata: {
  //       "nhc": pacienteNHC,
  //     }
  //   };
  // }, [pacienteNHC]);

  return (
    <>
      <div id='content' className="chatbot-container">
        <iframe
      src="https://www.chatbase.co/chatbot-iframe/leY0v-ICNNI5gno_UGvwe"
      width="100%"
      title="Chatbot"
    />
      </div>
    </>
  );
}